// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__1NFRJ","item":"Rating_item__DmlbN","itemActive":"Rating_itemActive__QsBtM"};